'use client';

import { c as _c } from "react/compiler-runtime";
import { getENV } from '../../../utils/env';
import { CrossDomainScript, OneTrustScript, OptanonScript } from './components';
import { useOneTrustParams } from './hooks';
export const OneTrustLegacy = t0 => {
  const $ = _c(11);
  const {
    customerKey
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getENV();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID,
    NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID,
    NEXT_PUBLIC_ONETRUST_ENABLED,
    NEXT_PUBLIC_LOCALE
  } = t1;
  const isCA = NEXT_PUBLIC_LOCALE === "en-CA";
  const oneTrustDomainScriptID = isCA ? NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID : NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID;
  let t2;
  if ($[1] !== customerKey) {
    t2 = {
      customerKey
    };
    $[1] = customerKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    token
  } = useOneTrustParams(t2);
  const isCrossDomainScriptEnabled = customerKey && oneTrustDomainScriptID && NEXT_PUBLIC_ONETRUST_ENABLED;
  let t3;
  if ($[3] !== customerKey || $[4] !== isCrossDomainScriptEnabled || $[5] !== token) {
    t3 = isCrossDomainScriptEnabled && Boolean(token) && <CrossDomainScript customerKey={customerKey} token={token} />;
    $[3] = customerKey;
    $[4] = isCrossDomainScriptEnabled;
    $[5] = token;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <OneTrustScript scriptId={oneTrustDomainScriptID} />;
    t5 = <OptanonScript />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3) {
    t6 = <>{t3}{t4}{t5}</>;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};